'use client';

import { useSyncExternalStore } from 'react';

import {
	CONSENT_EVENT,
	CONSENT_STORAGE_KEY,
	type ConsentValue,
	readConsent,
} from './consent';

function subscribe(onChange: () => void): () => void {
	const onStorage = (event: StorageEvent) => {
		if (event.key === CONSENT_STORAGE_KEY) onChange();
	};
	window.addEventListener(CONSENT_EVENT, onChange);
	window.addEventListener('storage', onStorage);
	return () => {
		window.removeEventListener(CONSENT_EVENT, onChange);
		window.removeEventListener('storage', onStorage);
	};
}

export function useConsent(): ConsentValue | null {
	return useSyncExternalStore(subscribe, readConsent, () => null);
}
